export const patternIssuerUnitCodeRus = /^\d\d\d-\d\d\d$/;
export const patternIssuerUnitCodeOther = /^[а-яёА-ЯЁa-zA-Z-—\d\\/\\ ]+$/;
